export default "__VITE_ASSET__2mMAd6Vs__"